// extracted by mini-css-extract-plugin
export default {"wrapper":"Hidden_wrapper_ad52c","content":"Hidden_content_f498e"};